import script from "./DoughnutChartBaseWrapper.vue?vue&type=script&lang=ts&setup=true"
export * from "./DoughnutChartBaseWrapper.vue?vue&type=script&lang=ts&setup=true"

import "./DoughnutChartBaseWrapper.vue?vue&type=style&index=0&id=0bae35e2&lang=scss&scoped=true"
import "./DoughnutChartBaseWrapper.vue?vue&type=style&index=1&id=0bae35e2&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bae35e2"]])

export default __exports__